// import React, { useEffect, useState, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import "../style/AdminImportantLinks.css";
// import Autocomplete from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
// import Pagination from "@mui/material/Pagination";
// import { AbstractAPI } from "../api";
// import AddIcon from "@mui/icons-material/Add";
// import { set } from "rsuite/esm/internals/utils/date";


// const Adminyoutubelink = () => {
//   const navigate = useNavigate();

//   const [links, setLinks] = useState([]);
//   const [formData, setFormData] = useState({
//     id: null,
//     youtube_url: "",
//     title: "",
//     category: "",
//     year: "",
//     status: "active",
//   });

//   const [editing, setEditing] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [allCategories, setAllCategories] = useState([]); // all possible categories
//   const [allYears, setAllYears] = useState([]);      
//       const [Speakers, setSpeakers] = useState([{ id: 1, name: "" }]);     // all possible years
//   const [page, setPage] = useState(1);
//   const rowsPerPage = 12;

//   const paginatedLinks = links.slice(
//     (page - 1) * rowsPerPage,
//     page * rowsPerPage
//   );

//   useEffect(() => {
//     fetchLinks();
//     fetchAbstractData();
//   }, []);


//   const fetchLinks = async () => {
//     try {
//       const data = await AbstractAPI.getAllYoutubeLinks();
//       setLinks(data);
//     } catch (err) {
//       console.error("Failed to load links", err);
//     }
//   };




//   const fetchAbstractData = async () => {
//     try {
//       const { categories, years } =
//         await AbstractAPI.getUniqueCategoriesAndYears();

//       setAllCategories(categories);
//       setAllYears(years);
//     } catch (err) {
//       console.error("Failed to load dropdown data", err);
//     }
//   };



//   const filteredCategories = useMemo(() => {
//     if (!formData.year) {
//       return allCategories; // show all if no year selected
//     }

//     const selectedYearNum = Number(formData.year);

//     // Find all categories used in the fetched links for this year
//     const catsForYear = links
//       .filter((link) => Number(link.year) === selectedYearNum)
//       .map((link) => link.category)
//       .filter(Boolean);

//     // Also include categories from abstract data that appear in this year (if needed)
//     // Here we use links data as source of truth for what's actually used
//     const uniqueCats = [...new Set(catsForYear)].sort();

//     return uniqueCats.length > 0 ? uniqueCats : allCategories;
//   }, [formData.year, links, allCategories]);


//   const validate = () => {
//     const e = {};
//     const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
//     const currentYear = new Date().getFullYear();

//     if (!formData.youtube_url.trim()) e.youtube_url = "YouTube link is required";
//     else if (!youtubeRegex.test(formData.youtube_url))
//       e.youtube_url = "Enter valid YouTube URL";

//     if (!formData.title.trim()) e.title = "Title is required";
//     if (!formData.category.trim()) e.category = "Category is required";
//     if (!formData.year) e.year = "Year is required";
//     else if (
//       isNaN(formData.year) ||
//       formData.year < 2000 ||
//       formData.year > currentYear
//     )
//       e.year = `Enter valid year (2000 - ${currentYear})`;

//     setErrors(e);
//     return Object.keys(e).length === 0;
//   };


// const handleSubmit = async (e) => {
//   e.preventDefault();
//   if (!validate()) return;

//   try {

//     const payload = {
//       youtube_url: formData.youtube_url,
//       title: formData.title,
//       category: formData.category,
//       year: Number(formData.year),
//       status: formData.status,
//     };

//     let data;

//     if (editing) {
//       data = await AbstractAPI.updateYoutubeLink(formData.id, payload);
//       setLinks(links.map((l) => (l.id === data.id ? data : l)));
//     } else {
//       data = await AbstractAPI.createYoutubeLink(payload);
//       setLinks([data, ...links]);
//       setPage(1);
//     }

//     resetForm();
//   } catch (err) {
//     console.error("Save failed", err);
//   }
// };
//   const resetForm = () => {
//     setFormData({
//       id: null,
//       youtube_url: "",
//       title: "",
//       category: "",
//       year: "",
//       status: "active",
//     });
//     setEditing(false);
//     setErrors({});
//   };


// const confirmDelete = async () => {
//   if (!deleteTarget) return;

//   try {
//     await AbstractAPI.deleteYoutubeLink(deleteTarget.id);
//     setLinks(links.filter((l) => l.id !== deleteTarget.id));
//     setPage(1);
//     setDeleteTarget(null);
//   } catch (err) {
//     console.error("Delete failed", err);
//   }
// };
//     const handleAddSpeaker = () => {
//         if (Speakers.length < 4) {
//             const newId = Math.max(...Speakers.map(s => s.id), 0) + 1;
//             setSpeakers([...Speakers, { id: newId, name: "" }]);
//         }
//     };

//     const handleRemoveSpeaker = (id) => {
//         if (Speakers.length > 1) {
//             setSpeakers(Speakers.filter(speaker => speaker.id !== id));
//         }
//     };

//   return (
//     <div className="admin-links-page">
//       <div className="page-header">
//         <button className="back-btn" onClick={() => navigate(-1)}>
//           ← Back
//         </button>
//         <h2>Manage YouTube Videos</h2>
//       </div>

//       {/* FORM */}
//       <form className="adminformimportant" onSubmit={handleSubmit}>
//         {/* YEAR DROPDOWN - strict */}
//         <div className="form-group">
//           <label>Year</label>
//           <Autocomplete
//             options={allYears.map(String)}
//             value={formData.year ? String(formData.year) : null}
//             onChange={(event, newValue) => {
//               setFormData({
//                 ...formData,
//                 year: newValue ? Number(newValue) : "",
//                 // Reset category when year changes (good UX)
//                 category: "",
//               });
//             }}
//             disableClearable={false}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 size="small"
//                 error={!!errors.year}
//                 helperText={errors.year}
//                 placeholder="Select year"
//               />
//             )}
//           />
//         </div>

//         {/* CATEGORY DROPDOWN - filtered by selected year */}
//         <div className="form-group">
//           <label>Video Category</label>
//           <Autocomplete
//             options={filteredCategories}
//             value={formData.category || null}
//             onChange={(event, newValue) => {
//               setFormData({ ...formData, category: newValue || "" });
//             }}
//             disableClearable={false}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 size="small"
//                 error={!!errors.category}
//                 helperText={errors.category || (formData.year && filteredCategories.length === 0 ? "No categories available for this year" : "")}
//                 placeholder="Select category"
//               />
//             )}
//           />
//         </div>

//         {/* TITLE */}
//         <div className="form-group">
//           <label>Video Title</label>
//           <input
//             value={formData.title}
//             className={errors.title ? "error-input" : ""}
//             placeholder="Video Title"
//             onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//           />
//           {errors.title && <span className="error">{errors.title}</span>}
//         </div>

//         {/* URL */}
//         <div className="form-group">
//           <label>YouTube URL</label>
//           <input
//             value={formData.youtube_url}
//             className={errors.youtube_url ? "error-input" : ""}
//             placeholder="https://youtube.com/..."
//             onChange={(e) => setFormData({ ...formData, youtube_url: e.target.value })}
//           />
//           {errors.youtube_url && <span className="error">{errors.youtube_url}</span>}
//         </div>

//         {/* SPEAKER */}
//         <div className="form-group">
//          <label className="label">Speaker</label>
//                         <button
//                             type="button"
//                             className="btn btn-secondary"
//                             onClick={handleAddSpeaker}
//                             disabled={Speakers.length >= 4}
//                         >
//                             <AddIcon /> Add Speaker
//                         </button>
//                         </div>

//         {/* STATUS */}
//         <div className="form-group">
//           <label>Status</label>
//           <select
//             value={formData.status}
//             onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//           >
//             <option value="active">Active</option>
//             <option value="inactive">Inactive</option>
//           </select>
//         </div>

//         <div className="form-actions">
//           <button className="primary-btn" type="submit">
//             {editing ? "Update" : "Add"}
//           </button>
//           {editing && (
//             <button type="button" className="secondary-btn" onClick={resetForm}>
//               Cancel
//             </button>
//           )}
//         </div>
//       </form>

//       {/* TABLE */}
//       <div className="table-section">
//         <h3>Saved Videos</h3>
//         <table className="admin-table">
//           <thead>
//             <tr>
//               <th>Category</th>
//               <th>Title</th>
//               <th>Year</th>
//               <th>URL</th>
//               <th>Status</th>
//               <th>Speaker</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedLinks.map((item) => (
//               <tr key={item.id}>
//                 <td>{item.category}</td>
//                 <td>{item.title}</td>
//                 <td>{item.year}</td>
//                 <td>
//                   <a href={item.youtube_url} target="_blank" rel="noreferrer">
//                     View
//                   </a>
//                 </td>
//                 <td>{item.speaker || "—"}</td>

//                 <td>{item.status}</td>
//                 <td className="actions">
//                   <button
//                     onClick={() => {
//                       setFormData({
//                         id: item.id,
//                         youtube_url: item.youtube_url,
//                         title: item.title,
//                         category: item.category,
//                         year: String(item.year), // ensure string for Autocomplete
//                         status: item.status,
//                       });
//                       setEditing(true);
//                     }}
//                   >
//                     Edit
//                   </button>
//                   <button className="danger" onClick={() => setDeleteTarget(item)}>
//                     Delete
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
//           <Pagination
//             count={Math.ceil(links.length / rowsPerPage)}
//             page={page}
//             onChange={(e, value) => setPage(value)}
//             color="primary"
//           />
//         </div>
//       </div>

//       {/* DELETE MODAL */}
//       {deleteTarget && (
//         <div className="delete-modal-overlay">
//           <div className="delete-modal">
//             <h4>Delete Video?</h4>
//             <p>Are you sure you want to delete "{deleteTarget.title}"?</p>
//             <div className="delete-modal-actions">
//               <button className="secondary-btn" onClick={() => setDeleteTarget(null)}>
//                 Cancel
//               </button>
//               <button className="danger-btn" onClick={confirmDelete}>
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Adminyoutubelink;
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../style/AdminImportantLinks.css";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Pagination from "@mui/material/Pagination";
import { AbstractAPI } from "../api";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useRef } from "react";

const Adminyoutubelink = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [links, setLinks] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    youtube_url: "",
    title: "",
    category: "",
    year: "",
    status: "active",
  });

  const [Speakers, setSpeakers] = useState([{ id: 1, title: "", first_name: "", last_name: "" }]);
  const [editing, setEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [allCategories, setAllCategories] = useState([]);
  const [allYears, setAllYears] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [page, setPage] = useState(1);
  const rowsPerPage = 12;

  const paginatedLinks = links.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  useEffect(() => {
    fetchLinks();
    fetchAbstractData();
  }, []);

  const fetchLinks = async () => {
    try {
      const data = await AbstractAPI.getAllYoutubeLinks();
      setLinks(data);
    } catch (err) {
      console.error("Failed to load links", err);
    }
  };

  const fetchAbstractData = async () => {
    try {
      const { categories, years } =
        await AbstractAPI.getUniqueCategoriesAndYears();
      setAllCategories(categories);
      setAllYears(years);
    } catch (err) {
      console.error("Failed to load dropdown data", err);
    }
  };

  const filteredCategories = useMemo(() => {
    if (!formData.year) return allCategories;

    const selectedYearNum = Number(formData.year);

    const catsForYear = links
      .filter((link) => Number(link.year) === selectedYearNum)
      .map((link) => link.category)
      .filter(Boolean);

    const uniqueCats = [...new Set(catsForYear)].sort();

    return uniqueCats.length > 0 ? uniqueCats : allCategories;
  }, [formData.year, links, allCategories]);

  const validate = () => {
    const e = {};
    const youtubeRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
    const currentYear = new Date().getFullYear();

    if (!formData.youtube_url.trim())
      e.youtube_url = "YouTube link is required";
    else if (!youtubeRegex.test(formData.youtube_url))
      e.youtube_url = "Enter valid YouTube URL";

    if (!formData.title.trim()) e.title = "Title is required";
    if (!formData.category.trim()) e.category = "Category is required";

    if (!formData.year) e.year = "Year is required";
    else if (
      isNaN(formData.year) ||
      formData.year < 2000 ||
      formData.year > currentYear
    )
      e.year = `Enter valid year (2000 - ${currentYear})`;

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const payload = {
        youtube_url: formData.youtube_url,
        title: formData.title,
        category: formData.category,
        year: Number(formData.year),
        status: formData.status,
        speakers: Speakers.map((s) => ({
          title: s.title,
          first_name: s.first_name,
          last_name: s.last_name,
        })).filter(s => s.first_name || s.last_name),
      };

      let data;

      if (editing) {
        data = await AbstractAPI.updateYoutubeLink(formData.id, payload);
        setLinks(links.map((l) => (l.id === data.id ? data : l)));
      } else {
        data = await AbstractAPI.createYoutubeLink(payload);
        setLinks([data, ...links]);
        setPage(1);
      }

      resetForm();
    } catch (err) {
      console.error("Save failed", err);
    }
  };

  const handleBulkUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const res = await AbstractAPI.bulkUploadYoutubeLinks(file);
      alert(res.message || "Bulk upload successful");
      fetchLinks();
    } catch (err) {
      console.error("Bulk upload failed", err);
      alert("Bulk upload failed: " + (err.response?.data?.error || err.message));
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const resetForm = () => {
    setFormData({
      id: null,
      youtube_url: "",
      title: "",
      category: "",
      year: "",
      status: "active",
    });
    setSpeakers([{ id: 1, title: "", first_name: "", last_name: "" }]);
    setEditing(false);
    setErrors({});
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;

    try {
      await AbstractAPI.deleteYoutubeLink(deleteTarget.id);
      setLinks(links.filter((l) => l.id !== deleteTarget.id));
      setDeleteTarget(null);
      setPage(1);
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const handleAddSpeaker = () => {
    if (Speakers.length < 8) {
      const newId = Math.max(...Speakers.map((s) => s.id), 0) + 1;
      setSpeakers([...Speakers, { id: newId, title: "", first_name: "", last_name: "" }]);
    }
  };

  const handleRemoveSpeaker = (id) => {
    if (Speakers.length > 1) {
      setSpeakers(Speakers.filter((s) => s.id !== id));
    }
  };

  return (
    <div className="admin-links-page">
      <div className="page-header">
        <button className="clear-filters-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h2>Manage YouTube Videos</h2>

        <div style={{ marginLeft: "auto", display: "flex", gap: "10px" }}>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            accept=".xlsx, .xls"
            onChange={handleBulkUpload}
          />
          <button
            className="upload-btn"
            onClick={() => fileInputRef.current.click()}
          >
            <CloudUploadIcon /> Bulk Upload
          </button>
        </div>
      </div>

      {/* FORM */}
      <form className="adminformimportant" onSubmit={handleSubmit}>
        {/* YEAR */}
        <div className="form-group">
          <label>Year</label>
          <Autocomplete
            options={allYears.map(String)}
            value={formData.year ? String(formData.year) : null}
            onChange={(e, val) =>
              setFormData({
                ...formData,
                year: val ? Number(val) : "",
                category: "",
              })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                error={!!errors.year}
                helperText={errors.year}
              />
            )}
          />
        </div>

        {/* CATEGORY */}
        <div className="form-group">
          <label>Video Category</label>
          <Autocomplete
            options={filteredCategories}
            value={formData.category || null}
            onChange={(e, val) =>
              setFormData({ ...formData, category: val || "" })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                error={!!errors.category}
                helperText={errors.category}
              />
            )}
          />
        </div>

        {/* TITLE */}
        <div className="form-group">
          <label>Title</label>
          <input
            value={formData.title}
            className={errors.title ? "error-input" : ""}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
          />
          {errors.title && <span className="error">{errors.title}</span>}
        </div>

        {/* URL */}
        <div className="form-group">

          <label>YouTube URL</label>
          <input
            value={formData.youtube_url}
            className={errors.youtube_url ? "error-input" : ""}
            onChange={(e) =>
              setFormData({ ...formData, youtube_url: e.target.value })
            }
          />
          {errors.youtube_url && (
            <span className="error">{errors.youtube_url}</span>
          )}
        </div>

        {/* STATUS */}
        <div className="form-group">
          <label>Status</label>
          <select
            value={formData.status}
            onChange={(e) =>
              setFormData({ ...formData, status: e.target.value })
            }
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {/* SPEAKERS */}
        <div className="form-group speaker-form-group">
          <div className="speaker-header">
            <label>Speakers (Up to 8)</label>
            <button
              type="button"
              className="btn-secondary"
              onClick={handleAddSpeaker}
              disabled={Speakers.length >= 8}
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              <AddCircleOutlineIcon fontSize="small" /> Add Speaker
            </button>
          </div>

          {Speakers.map((speaker, index) => (
            <div key={speaker.id} className="speaker-row">
              <select
                value={speaker.title}
                onChange={(e) =>
                  setSpeakers(
                    Speakers.map((s) =>
                      s.id === speaker.id
                        ? { ...s, title: e.target.value }
                        : s
                    )
                  )
                }
                className="speaker-title-select"
              >
                <option value="">Title</option>
                <option value="Dr.">Dr.</option>
                <option value="Mr.">Mr.</option>
                <option value="Ms.">Ms.</option>
                <option value="Prof.">Prof.</option>
              </select>

              <TextField
                value={speaker.first_name}
                onChange={(e) =>
                  setSpeakers(
                    Speakers.map((s) =>
                      s.id === speaker.id
                        ? { ...s, first_name: e.target.value }
                        : s
                    )
                  )
                }
                size="small"
                placeholder="First Name"
              />

              <TextField
                value={speaker.last_name}
                onChange={(e) =>
                  setSpeakers(
                    Speakers.map((s) =>
                      s.id === speaker.id
                        ? { ...s, last_name: e.target.value }
                        : s
                    )
                  )
                }
                size="small"
                placeholder="Last Name"
              />

              {Speakers.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveSpeaker(speaker.id)}
                  className="btn-danger btn-small"
                  title="Remove Speaker"
                >
                  <RemoveCircleOutlineIcon />
                </button>
              )}
            </div>
          ))}
        </div>



        {/* ACTIONS */}
        <div className="form-actions">
          <button className="primary-btn" type="submit">
            {editing ? "Update" : "Add"}
          </button>
          {editing && (
            <button
              type="button"
              className="secondary-btn"
              onClick={resetForm}
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* TABLE */}
      <div className="table-section">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>Saved Videos</h3>
          <div style={{ marginBottom: "16px", display: "flex", justifyContent: "flex-end" }}>
            <TextField
              placeholder="Search..."
              size="small"
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                width: 240,
                backgroundColor: "#fff",
                borderRadius: "8px",
              }}
            />
          </div>
        </div>


        <table className="admin-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Title</th>
              <th>Year</th>
              <th>URL</th>
              <th>Speakers</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {paginatedLinks
              .filter((item) =>
                item.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.speakers.some((s) =>
                  s.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  s.last_name.toLowerCase().includes(searchQuery.toLowerCase())
                )
              )
              .map((item) => (
                <tr key={item.id}>
                  <td>{item.category}</td>
                  <td>{item.title}</td>
                  <td>{item.year}</td>
                  <td>
                    <a href={item.youtube_url} target="_blank" rel="noreferrer">
                      View
                    </a>
                  </td>
                  <td>
                    {Array.isArray(item.speakers)
                      ? item.speakers.map(s => `${s.title || ""} ${s.first_name || ""} ${s.last_name || ""}`.trim()).join(", ")
                      : item.speaker || "—"}
                  </td>
                  <td>{item.status}</td>
                  <td className="actions">
                    <button
                      onClick={() => {
                        setFormData({
                          ...item,
                          year: String(item.year),
                        });

                        setSpeakers(
                          item.speakers?.map((s, i) => ({
                            id: i + 1,
                            ...s
                          })) || [{ id: 1, title: "", first_name: "", last_name: "" }]
                        );

                        setEditing(true);
                      }}
                    >
                      Edit
                    </button>

                    <button
                      className="danger"
                      onClick={() => setDeleteTarget(item)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
          <Pagination
            count={Math.ceil(links.length / rowsPerPage)}
            page={page}
            onChange={(e, val) => setPage(val)}
          />
        </div>
      </div>

      {/* DELETE MODAL */}
      {deleteTarget && (
        <div className="delete-modal-overlay">
          <div className="delete-modal">
            <h4>Delete Video?</h4>
            <p>{deleteTarget.title}</p>

            <div className="delete-modal-actions">
              <button
                className="secondary-btn"
                onClick={() => setDeleteTarget(null)}
              >
                Cancel
              </button>
              <button className="danger-btn" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Adminyoutubelink;